import React, {Fragment} from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";
import Select from "../../form/Select";
import CheckBox from "../../form/CheckBox";
import GroupDiscount from "./Discount/GroupDiscount";
import Conditions from "./Discount/Conditions";
import classNames from 'classnames';
import {CurrencyFormatter} from "../../../utils/formatters";

class DiscountForm extends React.Component {

    render() {
        let discountprops = null;
        let ultimate = null;
        let combinable = null;
        if (this.props.values.type === "groupdiscount") {
            discountprops = <GroupDiscount
                {...this.props}
            />;
            combinable = <Select
                {...this.props.getFieldProps("combinable")}
                label={false}
                optionname="DiscountCanCombine"
                storeType="local"
                objectValue={false}
                name="combinable"
                value={this.props.values.combinable}
                saveChanges={this.props.setFieldValue}
            />;
        } else if(this.props.values.type === "itemdiscount") {
            ultimate = <CheckBox
                {...this.props.getFieldProps("ultimate")}
                name="ultimate"
                value={this.props.values.ultimate}
                label="Kötelező kedvezmény"
                saveChanges={this.props.setFieldValue}
            />;
        }
        if (this.props.values.type !== "groupdiscount") {
            combinable = <CheckBox
                {...this.props.getFieldProps("combinable")}
                name="combinable"
                value={this.props.values.combinable}
                label={false}
                saveChanges={this.props.setFieldValue}
            />;
        }
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <div className="form-group">
                            <TextInput
                                name={this.props.componentConfig.idfield}
                                value={this.props.values[this.props.componentConfig.idfield]}
                                label="Kód"
                                role="idfield"
                                {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                            />
                        </div>
                    </div>
                    <div className="col-sm-8 col-sm-pull-4">
                        <div className="form-group">
                            <TextInput
                                name="name"
                                value={this.props.values.name}
                                label="Név"
                               saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("name")}
                            />
                        </div>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-3">
                        <TextInput
                            name="per_user_limit"
                            type="number"
                            value={this.props.values.per_user_limit}
                            label="Felhasználási limit felhasználónként"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("per_user_limit")}
                        />
                    </div>
                    <div className="col-md-3">
                        <TextInput
                            name="global_limit"
                            type="number"
                            value={this.props.values.global_limit}
                            label="Felhasználási limit összesen"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("global_limit")}
                        />
                    </div>
                    <div className={classNames({"col-md-6": !ultimate, "col-md-3": ultimate})}>
                        <div className="form-group">
                            <Select
                                {...this.props.getFieldProps("type")}
                                optionname="DiscountType"
                                storeType="local"
                                objectValue={false}
                                name="type"
                                value={this.props.values.type}
                                label="Típus"
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                    </div>
                    {ultimate && <div className="col-md-3">
                        <div className="form-group">
                            <label className="control-label">&nbsp;</label>
                            {ultimate}
                        </div>
                    </div>}
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <Select
                                {...this.props.getFieldProps("discount_group")}
                                component="group"
                                storeType="local"
                                objectValue={false}
                                name="discount_group"
                                value={this.props.values.discount_group}
                                isClearable={true}
                                label="Csoport"
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                    </div>
                </div>
                {this.props.values.type === "cartdiscount" ? <div className="row form-row">
                    <div className="col-md-6 currency">
                        <TextInput
                            type="number"
                            name="condition_qty"
                            label="Minimum kosár érték"
                            formatter={CurrencyFormatter}
                            value={this.props.values.condition_qty}
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("condition_qty")}
                        />
                    </div>
                </div> : null}
                <div className="row form-row">
                    <div className={classNames({"col-md-4": this.props.values.type === "groupdiscount", "col-md-6": this.props.values.type !== "groupdiscount"})}>
                        <div className="form-group">
                            <label className="control-label">Kedvezmény</label>
                            <div className="row">
                                <div className="col-md-7">
                                    <TextInput
                                        type="number"
                                        name="value"
                                        label={false}
                                        value={this.props.values.value}
                                        saveChanges={this.props.setFieldValue}
                                        {...this.props.getFieldProps("value")}
                                    />
                                </div>
                                <div className="col-md-5">
                                    <Select
                                        {...this.props.getFieldProps("calculation_mode")}
                                        label={false}
                                        optionname="DiscountValueType"
                                        filter={this.props.values.type !== "cartdiscount" ? null : {field: "optionid", value: "fix_price", operator: "!="}}
                                        storeType="local"
                                        objectValue={false}
                                        name="calculation_mode"
                                        value={this.props.values.calculation_mode}
                                        saveChanges={this.props.setFieldValue}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                            <TextInput
                                type="text"
                                name="promo_code"
                                label="Kupon kód"
                                value={this.props.values.promo_code}
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("promo_code")}
                            />
                        </div>
                        <div className="form-group">
                            <label className="control-label">Összevonható</label>
                            {combinable}
                        </div>
                    </div>
                    {this.props.values.type !== "cartdiscount" ? <Fragment>
                    {(this.props.values.type === "groupdiscount" && <div className="col-md-4">
                        {discountprops}
                    </div>) || null}
                    <div className={classNames({"col-md-4": this.props.values.type === "groupdiscount", "col-md-6": this.props.values.type !== "groupdiscount"})}>
                        <label className="control-label">Kedvezmény cél szűrések</label>
                        <Conditions
                            {...this.props}
                            type="DiscountTarget"
                            name="targets"
                            conditions={this.props.values.targets}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    {this.props.values.type !== "packagediscount" && <div className="col-md-12">
                        <label className="control-label">Termék kizárás</label>
                        <Conditions
                            {...this.props}
                            type={"DiscountExclusion"}
                            name="exclusions"
                            conditions={this.props.values.exclusions}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>}
                    </Fragment> : null}
                </div>
            </form>
        );
    }
}

export default createForm(DiscountForm);
